// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import common from './js/common'

import axios from 'axios'

import { AppConfig } from '@/config/AppConfig';
import {Axios} from '@/api/Axios';
// import $ from 'jquery'
// import {openPopAlert, closePopAlert} from '@/js/commonJQuery'
import VueDaumPost from 'vue-daum-postcode'
import {LoginConfig} from '@/store/Constraints';

import $ from "expose-loader?exposes[]=$&exposes[]=jQuery!jquery";
import {showMenu,hideMenu, openPop,closePop,openPopAlert, closePopAlert,expandMemBar,downsizeMemBar} from '@/js/commonJQuery'
// import {showMenu,hideMenu,showDimmed, hideDimmed,openPop,closePop, openPopAlert, closePopAlert,expandMemBar,downsizeMemBar} from '@/js/commonJQuery'
// require('expose?$!expose?jQuery!jquery')
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import "vue-scroll-picker/dist/style.css"

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'


import VueMask from 'v-mask'
import VModal from 'vue-js-modal'

import CommonHeader from '@/components/common/CommonHeader.vue';
import PopCommonAlert from '@/components/common/PopCommonAlert.vue';
import PopCommonConfirm from '@/components/common/PopCommonConfirm.vue';

import IdentityVerification from '@/components/common/IdentityVerification.vue';
import CustomModal from "@/components/common/CustomModal.vue"
import EzPayView from '@/components/payment/EzPayView.vue';

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import {LocalStorageConfig} from "@/components/AppConstants";

import EventBus from "@/js/eventBus.js"

import {isMobile,isIOS,isAndroid} from 'mobile-device-detect';
import VueGapi from 'vue-gapi'
Vue.use(VueToast);

Vue.config.productionTip = false

Vue.use(VModal, {
  dynamicDefaults: {

    adaptive : true,
    scrollable : true,
    height: 'auto'
  }
})
Vue.use(VueGapi, {
  apiKey: 'AIzaSyC6Svsu0i3xO0-6QbkcdQilie-xV8DpV5c',
  clientId: '858716469463-fupveqa259i4qhlkhd84069j9tjcpntm.apps.googleusercontent.com',
  scope: 'profile',
})
Vue.use(VueMask);

Vue.use(common);
Vue.use(Loading);
Vue.use(VueMoment, {
  moment,
})

// Vue.filter('toCurrency', function (value) {
//   if (typeof value !== "number") {
//       return value;
//   }
//   var formatter = new Intl.NumberFormat('ko-KR', {
//       style: 'toCurrency',
//       currency: 'KRW',
//       minimumFractionDigits: 0
//   });
//   return formatter.format(value);
// });



router.beforeEach((to, from,next) =>{

  // console.log(`main.beforeach loginState`,this.loginState)
  if(to)console.log(`main.beforeach to`,to.path,JSON.stringify(to.path))
  if(from)console.log(`main.beforeach from`,from.path,JSON.stringify(from.path))

  // if(from)console.log(`main.beforeach currentRoute.path : `,router.currentRoute.path)

  //메인이 아닌 다른 주소로 들어온 경우 로그인 상태가 false인 경우 홈으로 강제로 보내버림.
  // if(to.path != "/" && to.path != '/login' && !to.path.startsWith('/member')){

    // if(to.path.startsWith('/order' || '/giftshop' || '/stamp' || '/findShop' || '/coupon' || '/card' || '/cart' || '/gift' || '/cart')){
    //   if(this.loginState != true){


    //     // this.showAlertMessage('로그인 후 이용할 수 있습니다.')
    //     if(window.confirm('로그인 후 이용할 수 있습니다.')){
    //       next('/')
    //     }
    //     return;
    //   }
    // }

    EventBus.$emit("closeAlert");
    EventBus.$emit("closeConfirm");
    next();
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-KR', {
      // style: 'currency',
      // currency: 'KRW',
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('toPhone', function (phoneNumber) {
  if (!phoneNumber) return "";
  phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

  let tmp = '';
  if (phoneNumber.length < 4) {
    tmp = phoneNumber;
  } else if (phoneNumber.length < 7) {
    tmp = phoneNumber.replace(/(\d{3})(\d{3})/, "$1-$2");
  } else if (phoneNumber.length == 8) {
    tmp = phoneNumber.replace(/(\d{4})(\d{4})/, "$1-$2");
  } else if (phoneNumber.length < 10) {
    if (phoneNumber.substr(0, 2) == '02') { //02-123-5678
      tmp = phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
    } else {
      tmp = phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
    }
  } else if (phoneNumber.length < 11) {
    if (phoneNumber.substr(0, 2) == '02') { //02-1234-5678
      tmp = phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    } else { //010-123-4567
      tmp = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }
  } else { //010-1234-5678
    tmp = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  return tmp;
});

Vue.filter('toTime', function (time) {
  if (!time) return "";

  let tmp = '';
  if (time.length === 4) {
    tmp = time.replace(/(\d{2})(\d{2})/, "$1:$2");
    return tmp;
  } else if (time.length === 6) {
    tmp = time.replace(/(\d{2})(\d{2})(\d{2})/, "$1:$2:$3");
    return tmp;
  }
  return time;
});

Vue.filter('toDate', function (date) {
  if (!date) return "";

  let tmp = '';
  if (date.length === 8) {
    tmp = date.replace(/(\d{4})(\d{2})(\d{2})/, "$1.$2.$3");
    return tmp;
  } else if (date.length === 6) {
    tmp = date.replace(/(\d{2})(\d{2})(\d{2})/, "$1.$2.$3");
    return tmp;
  }
  return tmp;
});

Vue.filter('toDateTime', function (dateTime) {
  if (!dateTime) return "";

  let tmp = '';
  if (dateTime.length === 12) {
    tmp = dateTime.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1.$2.$3 $4:$5");
    return tmp;
  } else if (dateTime.length === 10) {
    tmp = dateTime.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1.$2.$3 $4:$5");
    return tmp;
  }
  return tmp;
});

Vue.filter('toCardNum', function (num) {
  if (!num) return "";

  let tmp = '';
  if (num.length === 16) {
    tmp = num.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1 $2 $3 $4");
    return tmp;
  }
  return num;
});

Vue.config.errorHandler = function (err, vm, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  // console.log('Custom vue error handler: ', err, vm.name, info);

  console.log(`Custom vue error handler - > error : ${JSON.stringify(err)}, vm.name : ${vm.name|''}, info:${JSON.stringify(info)}`);
};
Vue.config.warnHandler = function (err, vm, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  // console.log('Custom vue warn handler: ', err, vm.name, info);

  console.log(`Custom vue warn handler - > error : ${JSON.stringify(err)}, vm.name : ${vm.name|''}, info:${JSON.stringify(info)}`);
};

// Prevent vue from spamming the console with "helpful" tips
Vue.config.productionTip = false;


Vue.mixin({
  data(){
    return {
      loading:null,
    }
  },
  create(){
    console.log(`main.create`);
  },

  beforeDestroy () {
    clearInterval(this.interval)
 },
  computed: {
    accessToken: function(){
      return store.getters[LoginConfig.ACCESS_TOKEN]
    },
    loginState: function(){
      return store.getters[LoginConfig.LOGIN_STATE]
      // return true;
    },
    loginData: function(){
      return store.getters[LoginConfig.LOGIN_DATA]
      // return true;
    },
    memberInfo:function(){
      // return {name:'test'}
      return store.getters[LoginConfig.MEMBER_DATA]
    },
    mainInfo:function(){
      return store.getters[LoginConfig.MAIN_DATA]
    },
    isOrderEnabled:function() {
      return store.getters[LoginConfig.ORDER_ENABLED]
    },
    isDeliveryEnabled:function(){
      return AppConfig.VUE_APP_DELIVERY_ENABLED && store.getters[LoginConfig.DELIVERY_ENABLED];
      // return store.getters[LoginConfig.DELIVERY_ENABLED]
    },
    isSNSEnabled:function(){
      return AppConfig.VUE_APP_SNS_ENABLED;
    },
    isQuickOrderEnabled:function(){
      return AppConfig.VUE_APP_QUICK_ORDER_ENABLED;
    },
    isMyMenuEnabled:function(){
      return AppConfig.VUE_APP_MY_MENU_ENABLED;
    },
    currentLocation:function(){
      let locString = localStorage.getItem(LocalStorageConfig.CurrentGeoLocation);
      console.log(`main.js -> locString : ${locString}`);
      console.log(this.memberInfo)
      if(locString){
        if(this.memberInfo && this.memberInfo.positionAgree == 'Y') {
          let loc = JSON.parse(locString);
          return loc;
        }
      }
      return {lat:37.5628226,lng:126.9756712}
    },
    deviceToken:function(){
      return localStorage.getItem(LocalStorageConfig.DeviceToken);
    },

  },
  methods:{
    checkLogin: function(){
      return store.getters[LoginConfig.LOGIN_STATE]
    },
    removeOne(arr) {
      var what, a = arguments, L = a.length, ax;
      while (L > 1 && arr.length) {
          what = a[--L];
          while ((ax= arr.indexOf(what)) !== -1) {
              arr.splice(ax, 1);
          }
      }
      return arr;
    },
    removeAll(arr){
      while (arr.length) { arr.pop(); }
    },
    showMenu:function(){
      showMenu();
    },

    hideMenu:function(){
      hideMenu();
    },
    openPop: function(name) {
      openPop(name);
    },
    closePop: function(){
      closePop();
    },
    openPopAlert: function(a, enableDimmedClick = true){
      openPopAlert(a, enableDimmedClick)
    },
    closePopAlert:function(){
      closePopAlert();
    },
    expandMemBar:function(){
      expandMemBar();
    },
    downsizeMemBar:function(){
      downsizeMemBar();
    },
    showAlert:function(msg, onConfirm, confirmText) {
      EventBus.$emit("showAlert", {msg: msg, onConfirm: onConfirm, confirmText: confirmText});
    },
    showAlertTitle:function(title, msg, onConfirm) {
      EventBus.$emit("showAlert", {title: title, msg: msg, onConfirm: onConfirm});
    },
    showConfirm:function(msg, onConfirm, onCancel, confirmText, cancelText) {
      EventBus.$emit("showConfirm", {msg: msg, onConfirm: onConfirm, onCancel: onCancel, confirmText: confirmText, cancelText: cancelText});
    },
    closeAlertConfirm:function() {
      EventBus.$emit("close");
    },

    openWeb(url) {
      console.log(url)
      if(isMobile && isIOS && window.webkit)
          window.webkit.messageHandlers.openWeb.postMessage(url);
      else if(isMobile && isAndroid && window.App)
          window.App.openWeb(url);
    },

    showLoading(value){

      // value? this.loading = this.$loading.show():this.loading.hide();
      // console.log(`main.js.methods.showLoading -> value:${value}`,this.loading);
      try {
        if(value){
            this.loading = this.$loading.show();
            setTimeout(() => {
              console.log(`main.js.methods.showLoading setTimeout -> value:${value}`,this.loading);
              if(this.loading != undefined) {
                this.loading.hide();
              }
            },11000)
        }else{

          if(this.loading != undefined) {
            this.loading.hide();
          }
        }
      }catch(e){
        console.log(e);
      }
    },
  }
})



Vue.component('common-header',CommonHeader)
Vue.component('pop-common-alert',PopCommonAlert)
Vue.component('pop-common-confirm',PopCommonConfirm)

Vue.component('identity-verification',IdentityVerification)
Vue.component('custom-modal',CustomModal)
Vue.component('ez-pay-view',EzPayView)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data(){
    return {interval:null,timeout:null}
  },
  created() {
    console.log(`main.created.axiosInit`);

    Axios.client.interceptors.response.use(function (response) {
      return response;
    },function (error) {
      console.log(`main.methods.axios.catch ->  error : ${JSON.stringify(error)}`);
      const {status} = error.response
      if (status === 401) {
        if(confirm(`로그인 시간이 만료되었습니다.`)){
          window.location = '/login';
        }
      }

      // return error;
      Promise.reject(error);
    });

    this.checkOpenPage()

  },
  beforeDestroy () {
    clearInterval(this.interval)
 },
 computed:{
  loginStateValue: function(){
    return this.store.getters[LoginConfig.LOGIN_STATE]
    // return true;
  },
 },
  methods:{
    checkOpenPage:function(){

      this.interval = setInterval(function(){

        let openPageUrl = localStorage.getItem(LocalStorageConfig.OpenPage);
        if(openPageUrl != null && openPageUrl != ''){

          //2021-05-21 : 김갑석 -> 로그인 상태에서만 해당 로직 구동되도록 수정함.
          if(store.getters[LoginConfig.LOGIN_STATE]){
            let currentPath = router.currentRoute.path
            console.log(`main.methods.checkOpenPage -> openPageUrl : ${openPageUrl} ,currentRoute.path : ${currentPath} ${JSON.stringify(currentPath)}`);
            localStorage.removeItem(LocalStorageConfig.OpenPage)

            EventBus.$emit("onHideAllModal");

            if(openPageUrl != null && openPageUrl.includes('/order/')){
              if(currentPath.includes('payprepaid/orderCompleted')){
                router.replace('/order/history').then(r =>{
                  router.push(openPageUrl).then(r =>{
                    console.log(`main.methods.checkOpenPage -> push ok`);
                  }).catch(e =>{
                    console.log(`main.methods.checkOpenPage -> error : ${e}`);
                  })
                })
              }else if(openPageUrl.includes('/order/store')){
                  router.push(openPageUrl).then(r =>{
                      console.log(`main.methods.store -> push ok`);
                  }).catch(e =>{
                      console.log(`main.methods.store -> error : ${e}`);
                  })
              }
              return;
            }else{
              router.push(openPageUrl).then(r =>{
                console.log(`main.methods.checkOpenPage -> push ok`);
              }).catch(e =>{
                console.log(`main.methods.checkOpenPage -> error : ${e}`);
              })
            }


            // setTimeout(() => {

              // router.push(openPageUrl).then(r =>{
              //   console.log(`main.methods.checkOpenPage -> push ok`);
              // }).catch(e =>{
              //   console.log(`main.methods.checkOpenPage -> error : ${e}`);
              // })
            // },500)

          }
        }
      },1000)

    },
  }
})





// WEBPACK FOOTER //
// ./src/main.js